import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';



export default class IQBox extends React.Component {


    constructor(props){
        super(props);
        this.state = {
            clicked: false
        }
      }


  render() {



     //handle the click on one of the buttons
     const handleOnMouseDown = (e) => {
         
        if(this.props.isAnswer)
        {
            //console.log("handleOnMouseDown")
            this.setState({clicked: true})
        }
   
       };

       


    //convert 0-8 position to X
    const getXPosition = (position) => {
         
        while (position > 0)
         {
             position -= 3
         }

         if(position < 0)
         {
             position += 3;
         }

         return position;

    }

    //convert 0-8 position to Y
    const getYPosition = (position) => {
         
         let row = Math.floor(position/3)

         return row;

    }



    
      




    //convert XY position to 0-8 position
    const getPositionFromXY = (x, y) => {


        return y * 3 + x

    }




    const move = (position, amountX, amountY) => {

        let x = getXPosition(position)
        let y = getYPosition(position)

        x += amountX
        y += amountY

        while(x > 2)
            {
                x -= 3
            }

        while(y > 2)
            {
                y -= 3
            }


        while(x < 0)
            {
                x += 3
            }

        while(y < 0)
            {
                y += 3
            }

        return getPositionFromXY(x, y)

    }


    var image_width = 40;
    var image_height = 40;


    //console.log("images: ", this.props.images[0])


    //console.log("this.props.instructions: ", this.props.instructions)


   

    var class0 = "IQImg b" + move(this.props.initial_positions[0], this.props.instructions[0].moveX*this.props.p, this.props.instructions[0].moveY*this.props.p)
    var class1 = "IQImg b" + move(this.props.initial_positions[1], this.props.instructions[1].moveX*this.props.p, this.props.instructions[1].moveY*this.props.p)
    var class2 = "IQImg b" + move(this.props.initial_positions[2], this.props.instructions[2].moveX*this.props.p, this.props.instructions[2].moveY*this.props.p)
    

    var inverted0 = -1
    var inverted1 = -1
    var inverted2 = -1

    for(var i = 0; i < this.props.p; i ++)
    {
        if(this.props.instructions[0].invert) { inverted0 *= -1 }
        if(this.props.instructions[1].invert) { inverted1 *= -1 }
        if(this.props.instructions[2].invert) { inverted2 *= -1 }
    }

  
    if(inverted0 > 0)
    {
        class0 += " b_invert"
    }
    if(inverted1 > 0)
    {
        class1 += " b_invert"
    }
    if(inverted2 > 0)
    {
        class2 += " b_invert"
    }



    var className = "IQBox"


    var sequence_number = this.props.p+1

    if(this.props.isAnswer)
    {
        sequence_number = "4"
    }
    
    if(this.props.visible == false)
    {
        return (

            <div className={className + " choice"}>

                <img class="question_mark" src="../images/iq/question.png"></img>

            </div>

        );
    }
    else
    {

        var classIs = "" 

        if(this.state.clicked == true)
        {
            //classIs = "hidden" 
        }

        if(this.props.isAnswer == true)
        {
            className += " choice" 
        }

        return (

            <div className={className} onMouseDown={handleOnMouseDown} onClick={this.props.handleClick} value={this.props.value}>


            <img value={this.props.value} className={class0} src={this.props.images[0]}></img>
            <img value={this.props.value} className={class1} src={this.props.images[1]}></img>
            <img onClick={this.props.handleClick}  value={this.props.value} className={class2 + " " + classIs} src={this.props.images[2]}></img>
            
            <div class="sequence_num">{sequence_number}</div>

            </div>

        );

    }

   
    
  }
}
